import { render, staticRenderFns } from "./split-deal-action.vue?vue&type=template&id=0e14af5a"
import script from "./split-deal-action.ts?vue&type=script&lang=ts&external"
export * from "./split-deal-action.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports